import { useNavigate, useLocation } from 'react-router-dom';
import NotificationBell from '../components/NotificationBell';
import ApiStatusBadge from '../components/ApiStatusBadge';

export default function Layout({ children }) {
  const navigate = useNavigate();
  const loc = useLocation();
  const name = sessionStorage.getItem('clinicName') || localStorage.getItem('clinicName') || 'Кабинет';

  // N-125: если это impersonation-вкладка (токен в sessionStorage) — чистим только её,
  // не трогая localStorage, где может жить реальная сессия клиники в другой вкладке.
  const logout = () => {
    if (sessionStorage.getItem('clinicToken')) sessionStorage.clear();
    else localStorage.clear();
    window.location.href = '/login';
  };

  const items = [
    { p: '/dashboard', l: 'Обзор' },
    { p: '/referrals', l: 'Направления' },
    { p: '/transactions', l: 'Транзакции' },
    { p: '/commissions', l: 'Комиссии' },
    { p: '/operations', l: 'Операции' },
    { p: '/stoplist', l: 'Стоп-лист врачей' },
    { p: '/services', l: 'Услуги' },
    { p: '/profile', l: 'Профиль' },
  ];

  const impersonating = sessionStorage.getItem('impersonated') === '1';

  return (
    <div style={{ ...s.page, ...(impersonating ? s.pageImpersonating : {}) }}>
      {impersonating && (
        <div style={s.impersonatedBar}>
          Вы просматриваете этот кабинет как администратор Refero.
        </div>
      )}
      <div style={s.sidebar}>
        <img src="/refero-logo-vert.svg" alt="Réfero" style={s.logoImg} />
        <div style={s.clinicName}>{name}</div>
        <nav style={s.nav}>
          {items.map(i => (
            <div key={i.p} onClick={() => navigate(i.p)}
              style={{ ...s.navItem, ...(loc.pathname === i.p ? s.navActive : {}) }}>{i.l}</div>
          ))}
        </nav>
        <div onClick={() => navigate('/support')} style={{ ...s.support, cursor: 'pointer' }}>Связаться с техподдержкой</div>
        <button style={s.logout} onClick={logout}>Выйти</button>
      </div>
      <div style={s.content}>
        <div style={s.topBar}>
          <ApiStatusBadge tokenKey="clinicToken" />
          <NotificationBell endpoint="/clinic-cabinet/notifications" tokenKey="clinicToken" viewAllPath="/notifications" />
        </div>
        {children}
      </div>
    </div>
  );
}

const s = {
  page: { display: 'flex', minHeight: '100vh', background: '#F6F8FB', fontFamily: 'Inter, system-ui, sans-serif' },
  sidebar: { width: 240, background: '#fff', borderRight: '1px solid #eef2f7', display: 'flex', flexDirection: 'column', padding: '24px 0', flexShrink: 0 },
  logoImg: { width: 120, height: 'auto', padding: '0 24px' },
  clinicName: { color: '#2EC4B6', fontSize: 13, fontWeight: 600, padding: '8px 24px 20px', borderBottom: '1px solid #eef2f7' },
  nav: { display: 'flex', flexDirection: 'column', gap: 4, padding: '16px 12px', flex: 1 },
  navItem: { padding: '11px 14px', borderRadius: 10, color: '#475569', fontSize: 14, cursor: 'pointer', fontWeight: 500 },
  navActive: { background: '#e9faf7', color: '#149e90', fontWeight: 600 },
  support: { margin: '0 12px 8px', textAlign: 'center', color: '#94a3b8', fontSize: 12, textDecoration: 'none' },
  logout: { margin: '0 12px', background: 'transparent', border: '1px solid #e2e8f0', color: '#64748b', padding: '10px', borderRadius: 10, cursor: 'pointer', fontSize: 13 },
  content: { flex: 1, padding: 32, overflow: 'auto' },
  topBar: { display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 10, marginBottom: 16 },
  pageImpersonating: { paddingTop: 40 },
  impersonatedBar: {
    position: 'fixed', top: 0, left: 0, right: 0, zIndex: 3000,
    background: '#1B2B4B', color: '#fff', textAlign: 'center',
    padding: '10px 16px', fontSize: 13, fontWeight: 600,
  },
};
